import { ApiApprover, Approver } from "../types/approveListReponse";
import axiosInstance from "./axiosInstance";



// API function to fetch approvers
export const getApproverListApi = async (): Promise<Approver[]> => {
  try {
    const response = await axiosInstance.get<ApiApprover[]>("/api/admin/getApprovers");
    // 🔹 Map displayName → name, userPrincipalName → email
    return response.data.map((a) => ({
      name: a.displayName,
      email: a.userPrincipalName
    }));
  } catch (error) {
    console.error("Error fetching approvers", error);
    return [];
  }
};
